import { Modal, ModalProps } from 'antd';

interface ModalFormProps extends ModalProps {
  title?: string;
  open: boolean;
  onCancel: () => void;
}

export default function ModalForm({
  title,
  open,
  onCancel,
  width = 800,
  footer,
  style,
  destroyOnClose = false,
  children,
  className,
  ...rest
}: ModalFormProps) {
  return (
    <Modal
      maskClosable={false}
      title={title}
      open={open}
      onCancel={onCancel}
      width={width}
      footer={footer}
      centered
      destroyOnHidden={destroyOnClose}
      className={className}
      style={style}
      {...rest} // forward các prop khác từ ModalProps
    >
      {children}
    </Modal>
  );
}
